import axios from 'axios';
import properties from '../properties';
import { base64toByteArrayConverter } from './downloadPdfHelper';
import componentConstants from '../messages/componentConstants';
import {
  addPlanExlusions,
  // commercialEvaluationPrompt,
  convertToJSONString,
  exclusionsCodesPrompts,
  exclusionsPrompts,
  extractAndSaveProvisionMatrixData,
  // extractAndSaveSPDProvisionMatrix,
  // formatandSaveFeeRecommendationsData,
  promptChain,
  // recommedationsPrompt,
} from './contractMetadataHelper';

export interface ComplianceCheck {
  question: string;
  check?: string;
  compliance_status: string;
  parameter?: string;
  exact_text: string;
  reason: string[];
}

export const createNamespace = async (namespace: string, docUrl: string) => {
  try {
    const response = await axios.post(
      properties.aiqBaseUrl + properties.contractBaseUrl + '/namespace',
      {
        namespace: namespace,
        file_url: docUrl,
      },
    );
    return response?.data;
  } catch (error) {
    throw error;
  }
};

export const extractReport = async (
  contractId: string,
  namespace: string,
  report: string,
  egNid?: string,
  compareContractId?: string,
  compareUrl?: string,
  draft_id?: string,
  isDraft?: boolean,
  employer?: string,
  markDownUrl?: string,
) => {
  switch (report) {
    case 'Compensation Transparency Compliance Check':
      // const compensationResponse = await extractReportApi(
      //   { namespace: namespace },
      //   '/red_flag/compensation_transparency',
      //   contractId,
      //   report,
      //   2,
      //   draft_id,
      //   isDraft,
      // );
      // const formatedResponse = formatCompensationTransparency(
      //   compensationResponse?.data?.result,
      // );
      // const clauseAlignmentResponse = await extractReportApi(
      //   { namespace: namespace },
      //   '/clause_alignment/compensation_transparency',
      //   contractId,
      //   report,
      //   2,
      //   draft_id,
      //   isDraft,
      // );
      // const analysis = clauseAlignmentResponse?.data?.result[0];

      // await addCompensationTransparency(
      //   contractId,
      //   formatedResponse,
      //   {
      //     extract_clauses: analysis?.Extract_clauses,
      //     analysis: analysis?.Analysis,
      //     clause: analysis?.Clause,
      //   },
      //   draft_id,
      //   isDraft,
      // );

      await axios.post(
        properties.aiqBaseUrl +
          properties.contractBaseUrl +
          '/extract-compensation-transparency',
        {
          eg_nid: egNid,
          document_url: namespace,
          markdown_url: markDownUrl,
          ...(isDraft ? { draft_id: draft_id } : { contract_id: contractId }),
        },
      );
      await generateReport(
        contractId,
        egNid!,
        employer!,
        'compensationTransparencyReport',
        '',
        draft_id,
      );
      break;
    case 'Gag Clause Prohibition Compliance Check':
      await axios.post(
        properties.aiqBaseUrl +
          properties.contractBaseUrl +
          '/extract-gag-clause',
        {
          eg_nid: egNid,
          document_url: namespace,
          ...(isDraft ? { draft_id: draft_id } : { contract_id: contractId }),
        },
      );

      // const gagResponse = await extractReportApi(
      //   { namespace: namespace },
      //   '/gag',
      //   contractId,
      //   report,
      //   1,
      //   draft_id,
      //   isDraft,
      // );
      // const clauses = formatGagClause(gagResponse?.data?.result);
      // await addGagClause(contractId, clauses, draft_id, isDraft);
      await generateReport(
        contractId,
        egNid!,
        employer!,
        'gagClauseReport',
        '',
        draft_id,
      );

      break;
    case 'Commercial Evaluation':
      // const recommedationsResponse = await promptChain(
      //   recommedationsPrompt.prompt,
      //   recommedationsPrompt.contexts,
      //   {
      //     document: namespace,
      //     document2:
      //       'https://storageblobprod.blob.core.windows.net/contract/static-uploads/Fee Schedule/Fee Schedule Evaluation.pdf',
      //   },
      //   'gpt-5-mini',
      // );
      // const feeCategoriesResponse = await promptChain(
      //   commercialEvaluationPrompt.prompt,
      //   commercialEvaluationPrompt.contexts,
      //   {
      //     document: markDownUrl ?? namespace,
      //   },
      //   'gpt-5-mini',
      //   'https://storageblobprod.blob.core.windows.net/contract/static-uploads/JSON Schemas/commercial_evaluation_json_schema.json',
      // );
      // await formatandSaveFeeRecommendationsData(
      //   feeCategoriesResponse,
      //   egNid ?? '',
      //   contractId,
      //   draft_id,
      // );
      await axios.post(
        properties.aiqBaseUrl +
          properties.contractBaseUrl +
          '/extract-commercial-evaluation',
        {
          document_url: namespace,
          eg_nid: egNid,
          ...(isDraft ? { draft_id: draft_id } : { contract_id: contractId }),
        },
      );
      await generateReport(
        contractId,
        egNid!,
        employer!,
        'commercialAnalysisReport',
        '',
        draft_id,
      );
      break;
    case 'Comparison with Stop Loss Agreement':
    case 'Comparison with Administrative Service Agreement':
      const isStopLossComparison =
        report === 'Comparison with Stop Loss Agreement';

      const interContractResponse = await extractInterContractApi(
        {
          asa: isStopLossComparison ? namespace : compareUrl,
          stoploss: isStopLossComparison ? compareUrl : namespace,
        },
        'asa-stoploss',
        contractId,
        report,
        draft_id,
        isDraft,
      );

      const categories = formatUpdatedInterContract(interContractResponse.data);

      const agreementIds = {
        asa: isStopLossComparison
          ? isDraft
            ? draft_id
            : contractId
          : compareContractId,
        stoploss: isStopLossComparison
          ? compareContractId
          : isDraft
          ? draft_id
          : contractId,
      };

      await addInterContract(
        egNid!,
        agreementIds,
        categories,
        isDraft,
        isStopLossComparison,
      );
      await generateReport(
        contractId,
        egNid!,
        employer!,
        'interContractReport',
        compareContractId,
        draft_id,
        'asa-stoploss',
      );
      break;

    case 'Comparison with Summary Plan Description':
      const interContractRes = await extractInterContractApi(
        {
          asa: namespace,
          pd: compareUrl,
        },
        'asa-tpa--pd',
        contractId,
        report,
        draft_id,
        isDraft,
      );

      const categoriesResponse = formatUpdatedInterContract(
        interContractRes?.data,
      );

      await addInterContract(
        egNid!,
        {
          asa: isDraft ? draft_id : contractId,
          pd: compareContractId,
        },
        categoriesResponse,
        isDraft,
      );
      await generateReport(
        contractId,
        egNid!,
        employer!,
        'interContractReport',
        compareContractId,
        draft_id,
        'spd-asa',
      );
      break;
    default:
      break;
  }
};

export const extractReportApi = async (
  params: any,
  endpoint: string,
  contractId?: string,
  reportName?: string,
  version?: number,
  draft_id?: string,
  isDraft?: boolean,
) => {
  const maxRetries = 3;

  for (let attempt = 1; attempt <= maxRetries; attempt++) {
    try {
      const response = await axios.post(
        properties.aiqBaseUrl + properties.contractBaseUrl + '/extract-report',
        {
          params: params,
          report_endpoint: endpoint,
          version: version ?? 1,
          ...(isDraft ? { draft_id: draft_id } : { contract_id: contractId }),
          report_name: reportName,
        },
      );

      // ✅ Retry if response is missing or response.data is falsy/null
      if (response?.data) {
        return response.data;
      }
    } catch (error) {}
  }

  // ❌ All retries failed
  throw new Error(
    'extractReportApi failed after 3 attempts (error or null response)',
  );
};

export const extractInterContractApi = async (
  params: any,
  type: string,
  contractId?: string,
  reportName?: string,
  draft_id?: string,
  isDraft?: boolean,
) => {
  const maxRetries = 3;

  for (let attempt = 1; attempt <= maxRetries; attempt++) {
    try {
      const response = await axios.post(
        properties.aiqBaseUrl +
          properties.contractBaseUrl +
          properties.extractInterContract,
        {
          params: params,
          type,
          ...(isDraft ? { draft_id: draft_id } : { contract_id: contractId }),
          report_name: reportName,
        },
      );
      if (response?.data) {
        return response.data;
      }
    } catch (error) {}
  }
  throw new Error(
    'extractReportApi failed after 3 attempts (error or null response)',
  );
};

export const formatCompensationTransparency = (data: any) => {
  if (!Array.isArray(data)) {
    return [];
  }

  const result = data
    ?.filter((sectionData: any) => sectionData !== null)
    ?.map((sectionData: any) => {
      const sectionKey = Object.keys(sectionData)[0];
      const section = sectionData[sectionKey];

      return {
        section: section?.name,
        definition: section?.definition,
        checkoffList: Object.keys(section)
          .filter((key) => key.startsWith('checkoff_list'))
          .map((checkKey) => {
            const checkItem = section?.[checkKey];
            return {
              question: checkItem?.question,
              compliance_status: String(checkItem?.answer)?.toLowerCase(),
              reason: Array.isArray(checkItem?.reason)
                ? checkItem?.reason
                : [checkItem?.reason],
              exact_text: checkItem?.exact_text,
              check: checkItem?.summary,
            };
          }),
      };
    });

  return result;
};

export const addCompensationTransparency = async (
  contractId: string,
  sections: any[],
  clauseAlignmentAnalysis: any,
  draft_id?: string,
  isDraft?: boolean,
) => {
  try {
    await axios.post(
      properties.aiqBaseUrl +
        properties.contractBaseUrl +
        '/add-compensation-transparency',
      {
        ...(isDraft ? { draft_id: draft_id } : { contract_id: contractId }),
        sections: sections,
        clauseAlignmentAnalysis: clauseAlignmentAnalysis,
      },
    );
  } catch (error) {
    throw error;
  }
};

export const formatGagClause = (data: any) => {
  const formattedArray: {
    clause_name: string;
    clause_aim: string;
    check_off_list: ComplianceCheck[];
  }[] = [];

  data?.forEach((item: any) => {
    if (item && typeof item === 'object') {
      // Loop through each standard (e.g., "standard_1", "standard_2")
      Object.values(item).forEach((standard: any) => {
        const formattedStandard = {
          clause_name: standard?.name || '',
          clause_aim: standard?.aim || '',
          check_off_list: [] as ComplianceCheck[],
        };

        // Check if the check-off list is in object format (e.g., checkoff_list_1, checkoff_list_2)
        if (typeof standard === 'object' && standard !== null) {
           
          Object.entries(standard).forEach(([key, value]) => {
            if (
              key.startsWith('checkoff_list') &&
              typeof value === 'object' &&
              value !== null
            ) {
              const checkoffItem = value as any;
              formattedStandard.check_off_list.push({
                question: checkoffItem?.question,
                check: checkoffItem?.summary,
                compliance_status: String(checkoffItem?.answer)?.toLowerCase(),
                reason: Array.isArray(checkoffItem?.reason)
                  ? checkoffItem?.reason
                  : [checkoffItem?.reason],
                exact_text: Array.isArray(checkoffItem?.exact_text)
                  ? checkoffItem?.exact_text
                  : [checkoffItem?.exact_text],
                parameter: '',
              });
            }
          });
        }

        formattedArray.push(formattedStandard);
      });
    }
  });

  return formattedArray;
};

export const addGagClause = async (
  contractId: string,
  clauses: any[],
  draft_id?: string,
  isDraft?: boolean,
) => {
  try {
    await axios.post(
      properties.aiqBaseUrl + properties.contractBaseUrl + '/add-gag-clause',
      {
        ...(isDraft ? { draft_id: draft_id } : { contract_id: contractId }),
        clauses: clauses,
      },
    );
  } catch (error) {
    throw error;
  }
};

export const formatInterContract = (data: any) => {
  const groupedData: any = {};

  // Iterate over the topics and group them by status
  Object.keys(data)?.forEach((key: any) => {
    const topic = data[key];
    const { status, name, reasons, asa, stoploss, pd } = topic;

    // Initialize category if not already present
    if (!groupedData[status]) {
      groupedData[status] = {
        category: status,
        description: '',
        topics: [],
      };
    }

    // Add the topic details to the respective category
    groupedData[status].topics.push({
      topic: name,
      reasons,
      asa_extracts: asa?.extract_data || [],
      stoploss_extracts: stoploss?.extract_data || [],
      pd_extracts: pd?.extract_data || [],
    });
  });

  // Convert the grouped data object to an array
  return Object.values(groupedData);
};

export const formatUpdatedInterContract = (data: any[]) => {
  const groupedData: any = {};

  data?.forEach((topic) => {
    const {
      topic_key,
      status,
      topic_name,
      reasons,
      asa_extracts,
      stoploss_extracts,
      pd_extracts,
      pbm_extracts,
      aim,
      chunks,
      slide_topic,
      legal_doctrine,
      legal_citation,
    } = topic;

    // Initialize category group
    if (!groupedData[status]) {
      groupedData[status] = {
        category: status,
        description: '',
        topics: [],
      };
    }

    // Push topic in same structure as before (with additions)
    groupedData[status].topics.push({
      key: topic_key,
      topic: topic_name,
      reasons: reasons || [],
      asa_extracts: asa_extracts || [],
      stoploss_extracts: stoploss_extracts || [],
      pd_extracts: pd_extracts || [],
      pbm_extracts: pbm_extracts || [],
      aim: aim || null,
      slide_topic: slide_topic || null,
      legal_doctrine: legal_doctrine || null,
      legal_citation: legal_citation || null,
      chunks: {
        asa: chunks?.asa || [],
        stoploss: chunks?.stoploss || [],
        pd: chunks?.pd || [],
        pbm: chunks?.pbm || [],
      },
    });
  });

  return Object.values(groupedData);
};

export const addInterContract = async (
  egNid: string,
  agreementIds: any,
  categories: any[],
  isDraft?: boolean,
  isStopLossComparison?: boolean,
) => {
  try {
    await axios.post(
      properties.aiqBaseUrl +
        properties.contractBaseUrl +
        '/add-inter-contract',
      {
        eg_nid: egNid,
        agreement_ids: agreementIds,
        categories: categories,
        isDraft,
        isStopLossComparison,
      },
    );
  } catch (error) {
    throw error;
  }
};

export const addGapAnalysis = async (
  egNid: string,
  agreementIds: any,
  analysis: any,
  isDraft?: boolean,
) => {
  try {
    await axios.post(
      properties.aiqBaseUrl + properties.contractBaseUrl + '/add-gap-analysis',
      {
        eg_nid: egNid,
        agreement_ids: agreementIds,
        analysis: analysis,
        isDraft,
      },
    );
  } catch (error) {
    throw error;
  }
};

export const handleDownloadReport = (
  reportName: string,
  employer: string,
  contractId: string,
  handleOpenSnackBar: any,
  egNid?: string,
  compareId?: string,
  type?: string,
  draftId?: string,
  documentUrl?: string,
) => {
  const token = JSON.parse(localStorage.getItem('token-storage') as string)
    ?.access_token;
  const messages = componentConstants.ORGANISMS.REPORTS_MODAL.SNACKBAR_MESSAGES;
  handleOpenSnackBar(messages.DOWNLOAD_REPORT, 'info', 5000);
  axios
    .post(
      properties.aiqBaseUrl + properties.downloadComplianceAssuranceReport,
      {
        contract_id: contractId,
        employer: employer,
        reportName: reportName,
        compare_agreement_id: compareId,
        eg_nid: egNid,
        type: type,
        draft_id: draftId,
        document_url: documentUrl,
      },
      {
        headers: {
          Authorization: token,
        },
      },
    )
    .then((res) => {
      if (res) {
        const byteArray = base64toByteArrayConverter(res.data?.data);
        const file = new Blob([byteArray], {
          type: 'application/pdf;base64',
        });
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL, '_blank');
        handleOpenSnackBar(messages.OPEN_SUCCESS, 'success', 5000);
      }
    })
    .catch((error) => {
      handleOpenSnackBar(
        error.response?.data?.error ?? messages.API_ERROR,
        'error',
        5000,
      );
    });
};

export const extractPlanDocsReport = async (
  planId: string,
  namespace: string,
  report: string,
  egNid?: string,
  compareContractId?: string,
  compareUrl?: string,
  employer?: string,
  markdownUrl?: string,
) => {
  switch (report) {
    case 'Comparison with Administrative Service Agreement':
      const interContractResponse = await extractInterContractApi(
        { pd: namespace, asa: compareUrl },
        'asa-tpa--pd',
        planId,
        report,
      );

      const categories = formatUpdatedInterContract(
        interContractResponse?.data,
      );

      await addInterContract(
        egNid!,
        { pd: planId, asa: compareContractId },
        categories,
      );
      await generateReport(
        planId,
        egNid!,
        employer!,
        'interContractReport',
        compareContractId,
        '',
        'spd-asa',
      );

      break;
    case 'Gap Analysis':
      await axios.post(
        properties.aiqBaseUrl +
          properties.contractBaseUrl +
          '/extract-gap-pd-stoploss',
        {
          plan_id: planId,
          contract_id: compareContractId,
          stoploss_url: compareUrl,
          pd_url: namespace,
          eg_nid: egNid,
        },
      );

      // const gapAnalysis = await extractReportApi(
      //   { pd: namespace, stoploss: compareUrl },
      //   '/gap/pd--stoploss',
      //   planId,
      //   report,
      // );

      // await addGapAnalysis(
      //   egNid!,
      //   { pd: planId, stoploss: compareContractId },
      //   gapAnalysis?.data?.result,
      // );
      await generateReport(
        planId,
        egNid!,
        employer!,
        'gapAnalysisReport',
        compareContractId,
      );
      break;
    case 'ERISA Regulatory Compliance Check':
      await axios.post(
        properties.aiqBaseUrl +
          properties.contractBaseUrl +
          '/extract-regulatory-compliance',
        {
          eg_nid: egNid,
          document_url: namespace,
          plan_id: planId,
        },
      );
      // const regulatoryResponse = await extractReportApi(
      //   { namespace: namespace },
      //   '/regulatory',
      //   planId,
      //   report,
      //   2,
      // );
      // const regulations = formatRegulatoryComplianceData(
      //   regulatoryResponse?.data?.result,
      // );
      // await addRegulatoryReport(planId, regulations, egNid!);
      await generateReport(planId, egNid!, employer!, 'regulatoryReport');
      break;

    case 'Coverage Check':
    case 'Overview':
      await extractAndSaveProvisionMatrixData(
        namespace,
        '',
        egNid!,
        '',
        'Summary Plan Document',
        '',
        planId,
      );
      break;
    case 'Exclusion Analysis':
      const { exclusions } = await promptChain(
        exclusionsPrompts?.prompt,
        exclusionsPrompts.contexts,
        { document: markdownUrl ?? namespace },
      );

      const exclusionChunks = [];
      for (let i = 0; i < exclusions.length; i += 3) {
        exclusionChunks.push(exclusions.slice(i, i + 3));
      }

      const exclusionCodes = [];
      for (const chunk of exclusionChunks) {
        try {
          const exclusionCodesContexts = {
            ...exclusionsCodesPrompts.contexts,
            exclusions: convertToJSONString(chunk),
          };

          const result = await promptChain(
            exclusionsCodesPrompts.prompt,
            exclusionCodesContexts,
          );

          exclusionCodes.push(result.results || []);
        } catch (error) {
          exclusionCodes.push([]);
        }
      }
      await addPlanExlusions(egNid!, planId, exclusionCodes.flat());
      break;
    case 'Comparison with PBM Service Agreement':
      const interContractRes = await extractInterContractApi(
        { pd: namespace, pbm: compareUrl },
        'pbm-pd',
        planId,
        report,
      );
      const category = formatUpdatedInterContract(interContractRes?.data);

      await addInterContract(
        egNid!,
        { pd: planId, pbm: compareContractId },
        category,
      );
      await generateReport(
        planId,
        egNid!,
        employer!,
        'interContractReport',
        compareContractId,
        '',
        'spd-pbm',
      );

      break;
    default:
      break;
  }
};

export const addRegulatoryReport = async (
  planId: string,
  regulations: any[],
  egNid: string,
) => {
  try {
    await axios.post(
      properties.aiqBaseUrl +
        properties.contractBaseUrl +
        '/add-regulatory-compliance',
      {
        eg_nid: egNid,
        plan_id: planId,
        regulations: regulations,
      },
    );
  } catch (error) {
    throw error;
  }
};

export const formatRegulatoryComplianceData = (data: any) => {
  if (!Array.isArray(data?.compliances)) {
    return [];
  }

  return data?.compliances
    .filter((item: any) => item !== null) // Remove null/undefined items
    .map((compliance: any) => ({
      regulation: compliance?.compliance_name || '',
      regulation_description: compliance?.compliance_description || '',
      applicability_status:
        compliance?.applicability_status?.toLowerCase() || '',
      applicability_reason: compliance?.applicability_reason || '',
      applicability_description: compliance?.applicability_description || '',
      compliance_status: compliance?.compliance_status?.toLowerCase() || '',
      compliance_reason: compliance?.compliance_reason || '',
      compliance_checklist:
        compliance?.questions && Array.isArray(compliance?.questions)
          ?  
            compliance?.questions?.map((q: any) => ({
              question: q?.question_text || '',
              answer: q?.answer?.toLowerCase() || '',
              reason: q?.reason || '',
              evidence: q?.evidence || '',
            }))
          : [],
    }));
};

export const generateReport = async (
  contract_id: string,
  eg_nid: string,
  employer: string,
  reportName: string,
  compare_agreement_id?: string,
  draft_id?: string,
  type?: string,
) => {
  try {
    await axios.post(properties.aiqBaseUrl + properties.generateReport, {
      contract_id,
      employer,
      reportName,
      eg_nid,
      compare_agreement_id,
      draft_id,
      type,
    });
  } catch (error) {
    throw error;
  }
};
